/**
 * Location health on the web (core locationhealth.ts decides everything): where an item's one action goes, which
 * picture each area and status shows. Pure, so the screens stay thin and the mapping is testable.
 */
import type { HealthAction, HealthStatus, VectorKey } from "@logwave/core";
import type { IconName } from "../components/Icons.tsx";

export const VECTOR_ICON: Record<VectorKey, IconName> = { food: "thermo", surfaces: "spray", restrooms: "restroom", pests: "bug", trash_floors: "trash", supplies: "box", other: "paper" };
export const STATUS_ICON: Record<HealthStatus, IconName> = { failed: "alert", late: "clock", never: "eye", soon: "clock", ok: "check" };

/** The in-app place an item's action goes (the health page never checks anything off itself). Home and business share these paths. */
export function healthActionPath(a: HealthAction): string {
  const id = encodeURIComponent(a.target.id);
  switch (a.kind) {
    case "log": return a.target.type === "check" ? `/do?check=${id}` : a.target.type === "template" ? `/do?log=${id}` : "/do";
    case "fix": return `/do/fix/${id}`;
    case "object": return `/places/${id}`;
    case "report": return `/report#${id}`;
    case "food": return "/food";
    case "order": return "/order";
    case "room": return `/rooms/check/${id}`;
  }
}

/** ?v= → a vector key the view has, else none. */
export function pickVector<T extends { key: string }>(vectors: readonly T[], wanted: string | null | undefined): T | undefined {
  return wanted ? vectors.find((v) => v.key === wanted) : undefined;
}
